import $ from "jquery";
import ko from "knockout";
import "jquery-ui/ui/widgets/datepicker";
import dateHelper from "flow/utils/dateHelper";
import register from "flow/knockout/register";

register.registerKnockoutBinding("dateLite", {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.value.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

        const subscriptions: KnockoutSubscription[] = [];

        //initialize datepicker with some optional options
        const options = allBindingsAccessor().datepickerOptions || {};

        const optionsChangedComputed = ko.pureComputed(function () {
            return ko.toJS(options);
        });

        const daysAfterStartDate = allBindingsAccessor.get("daysAfterStartDate");
        if (!!daysAfterStartDate && (ko.isObservable(options["minDate"]) || ko.isComputed(options["minDate"]))) {
            const minDateObservable = options["minDate"];
            options["minDate"] = ko.pureComputed(function () {
                return dateHelper.addDays(minDateObservable(), daysAfterStartDate);
            });
        }

        const optionsChangedSubscription = optionsChangedComputed.subscribe(function (newOptions) {
            const options = ko.toJS(newOptions);
            delete options.onClose;
            delete options.showOn;

            const keys = Object.keys(options);
            for (let i = 0; i < keys.length; i += 1) {
                $(element).datepicker("option", keys[i], options[keys[i]]);
            }
            valueAccessor().valueHasMutated();
            //valueAccessor().notifySubscribers();
        });
        subscriptions.push(optionsChangedSubscription);

        options.onClose = function (_text: any, _inputField: any) {
            const observable = valueAccessor();
            observable($(this).val());
            $(element).focus();
        };

        options.showOn = "never";

        const result = $(element).parents(".input-group");
        const button = $(result).find(".btn");

        const enableBinding = allBindingsAccessor.get("enable");
        if (enableBinding && $(button).length === 1) {
            if (ko.isObservable(enableBinding) || ko.isComputed(enableBinding)) {
                const enableSubscription = enableBinding.subscribe(function (enabled) {
                    if (enabled) {
                        $(button).prop("disabled", false);
                    } else {
                        $(button).prop("disabled", true);
                    }
                });
                $(button).prop("disabled", !enableBinding());
                subscriptions.push(enableSubscription);
            }
        }
        if (enableBinding === false) {
            $(button).prop("disabled", true);
        }
        const disableBinding = allBindingsAccessor.get("disable");
        if (disableBinding && $(button).length === 1) {
            if (ko.isObservable(disableBinding) || ko.isComputed(disableBinding)) {
                const disableSubscription = disableBinding.subscribe(function (disabled) {
                    if (disabled) {
                        $(button).prop("disabled", true);
                    } else {
                        $(button).prop("disabled", false);
                    }
                });
                $(button).prop("disabled", disableBinding());
                subscriptions.push(disableSubscription);
            }
        }
        if (disableBinding === true) {
            $(button).prop("disabled", true);
        }

        $(element).datepicker(ko.toJS(options));

        if (button.length === 0) {
            // No button, we are probably in table and should show calendar on focus.
            $(element).click(function () {
                $(element).datepicker("show");
            });
        } else {
            // Button, show calendar on button but not on focus of input field.
            $(button).click(function () {
                // do not open calender if the element is disabled
                if (!$(element).attr("disabled")) $(element).datepicker("show");
            });
        }

        //handle the field changing
        $(element).on("change", function () {
            const observable = valueAccessor();
            if (typeof observable !== "function") {
                console.log(element);
            }
            observable($(element).val());
        });

        //handle disposal (if KO removes by the template binding)
        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            $(element).datepicker("destroy");
            subscriptions.forEach(s => s.dispose);
        });
    },
    update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        ko.bindingHandlers.value.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

        let value = ko.utils.unwrapObservable(valueAccessor());

        //handle date data coming via json from Microsoft
        if (String(value).indexOf("/Date(") == 0) {
            value = new Date(parseInt(value.replace(/\/Date\((.*?)\)\//gi, "$1")));
        }

        const newDate = dateHelper.formatIfComplete(value);
        const current = $(element).val();

        if (newDate !== current) {
            $(element).datepicker("setDate", newDate).trigger("change");
        }
    }
});
